import React, { Component } from "react";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import {
  Container,
  Col,
  Form,
  FormGroup,
  Spinner,
  Button,
} from "react-bootstrap";
import { connect } from "react-redux";
import {
  GetClusters,
  GetAreas,
  GetBranchByCode,
} from "../../../../store/actions/crdm_service_actions";
import {
  GetOverallExpired_v4,
  GetExpiredByArea_v4,
  GetExpiredByCluster_v4,
  GetExpiredByBranch_v4,
} from "../../../../store/actions/reports-v4/sales_service_actions";
import moment from "moment";
import { closeModal } from "../../../../store/actions/ModalActions";
import { renderChartTitle } from "../../../../helpers/chartTitleBuilder";
import {
  moduleNames,
  OperationScope,
} from "../../../../helpers/dashboardModuleNames";
import { SetChartSalesExpiredTitle } from "../../../../store/actions/reports/chart_title_actions";
import AsyncSelect from "react-select/async";
import { toastr } from "react-redux-toastr";
import { v4 as uuidv4 } from "uuid";

const createData = (uuid, from, to) => {
  return { uuid, from, to };
};
const fromDate = new Date();
const toDate = new Date();

fromDate.setMonth(fromDate.getMonth());
toDate.setMonth(toDate.getMonth());

class ExpiredViewFilter extends Component {
  state = {
    clusters: [],
    areas: [],
    branches: [],

    isBusy: false,
    isRunningBalance: true,
    from: fromDate,
    to: toDate,
    toView: "overall",
    previewText: "All Clusters",
    isClusterLoading: false,
    isAreaLoading: false,

    clusterSelectContext: null,
    areaSelectContext: null,

    clusterId: null,
    areaId: null,
    date: Date.now(),
  };

  componentDidMount() {
    this.openLoading();

    this.props.GetClusters().then((resp) => {
      if (resp.problem === null) {
        this.setState({ isClusterLoading: false, clusters: resp.data });
      }
    });

    this.props.GetAreas().then((resp) => {
      if (resp.problem === null) {
        this.setState({ isAreaLoading: false, areas: resp.data });
      }
    });

    this.closeLoading();
  }

  openLoading = () => {
    this.setState({ isClusterLoading: true, isAreaLoading: true });
  };
  closeLoading = () => {
    this.setState({ isClusterLoading: false, isAreaLoading: false });
  };

  handleCluster = (d) => {
    this.setState({
      clusterId: d.target.value.id,
      clusterSelectContext: d.target.value,
    });
  };

  handleArea = (d) => {
    this.setState({
      areaId: d.target.value.areaCode,
      areaSelectContext: d.target.value,
    });
  };
  //filter daterange
  createFilterDate = () => {
    let { dates } = this.state;
    dates.push(createData(uuidv4(), Date.now(), Date.now()));
    this.setState({ dates });
  };

  handleRadioChanged = (e) => {
    this.setState({
      toView: e.target.value,
      clusterId: null,
      areaId: null,
      areaSelectContext: null,
      clusterSelectContext: null,
    });

    switch (e.target.value) {
      case "clusters":
        this.setState({ previewText: "All Clusters" });
        break;

      case "areas":
        this.setState({ previewText: "All Areas" });

        break;
      default:
        this.setState({ previewText: "No Values" });
        break;
    }
  };

  handleCoveredDate = (fieldData) => {
    this.setState({ date: fieldData });
  };

  //date range
  handleFrom = (fieldData) => {
    this.setState({ from: fieldData });
  };

  handleTo = (fieldData) => {
    this.setState({ to: fieldData });
  };

  renderClusters = () => {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">Cluster</InputLabel>
        <Select
          id="demo-simple-select-outlined"
          disabled={!this.state.toView === "clusters"}
          value={this.state.clusterSelectContext}
          onChange={this.handleCluster}
        >
          {this.state.clusters.map((data, key) => {
            return (
              <MenuItem value={data} key={key}>
                <span>{data.name} </span>
                <span className="text-danger ml-2 bold">{data.code}</span>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  };

  renderAreas = () => {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">Area</InputLabel>
        <Select
          id="demo-simple-select-outlined"
          disabled={!this.state.toView === "clusters"}
          value={this.state.areaSelectContext}
          onChange={this.handleArea}
        >
          {this.state.areas.map((data, key) => {
            return (
              <MenuItem value={data} key={key}>
                {`${data.areaName}`}
                <span className="text-danger">({data.areaCode})</span>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  };

  PremiseGetBranchByCode = (code) => {
    return this.props.GetBranchByCode(code);
  };
  loadOptions = (inputValue, callback) => {
    // do some work

    if (inputValue.length >= 3) {
      this.PremiseGetBranchByCode(inputValue).then((resp) => {
        if (resp.problem === null) {
          if (resp.data && resp.data.length > 0) {
            const currentItem = resp.data[0];
            return callback([
              {
                label: `(${currentItem.branchCode}) ${currentItem.branchName}`,
                value: currentItem.branchCode,
              },
            ]);
          }

          return callback([]);
        }

        return callback([]);
      });
    } else {
      return callback([]);
    }
  };

  renderFilterView = () => {
    switch (this.state.toView) {
      case "clusters":
        return this.renderClusters();

      case "areas":
        return this.renderAreas();

      case "branches":
        return this.renderBranches();

      default:
        return "";
    }
  };

  handlebranchCode = (fieldData) => {
    this.setState({ branches: fieldData });
  };

  renderBranches = () => {
    return (
      <FormControl variant="filled" fullWidth>
        <AsyncSelect
          isMulti={true}
          placeholder="Enter Branch Codes"
          cacheOptions
          defaultOptions
          onChange={this.handlebranchCode}
          loadOptions={this.loadOptions}
        />
      </FormControl>
    );
  };

  render() {
    return (
      <Container>
        <Form>
          <Form.Row>
            <FormGroup as={Col}>
              <FormControl className="d-inline">
                <RadioGroup
                  row
                  value={this.state.toView}
                  onChange={this.handleRadioChanged}
                >
                  <FormControlLabel
                    value="overall"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="overall"
                        name="radio-button"
                      />
                    }
                    label="Overall"
                  />
                  <FormControlLabel
                    value="clusters"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="clusters"
                        name="radio-button"
                      />
                    }
                    label="Clusters"
                  />
                  <FormControlLabel
                    value="areas"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="areas"
                        name="radio-button"
                      />
                    }
                    label="Areas"
                  />
                  <FormControlLabel
                    value="branches"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="branches"
                        name="radio-button"
                      />
                    }
                    label="Branches"
                  />
                </RadioGroup>
              </FormControl>
            </FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col}>{this.renderFilterView()}</FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col}>
              <DatePicker
                disableToolbar
                fullWidth
                autoOk
                disableFuture
                label="Covered Date"
                variant="inline"
                inputVariant="outlined"
                format="MMMM DD YYYY"
                openTo="year"
                views={["year", "month", "date"]}
                showTodayButton
                value={this.state.date}
                onChange={this.handleCoveredDate}
              />
            </FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup className="float-right" as={Col}>
              <Button
                disabled={this.state.isBusy}
                onClick={() => {
                  this.setState({ isBusy: true });
                  let { clusterId, areaId } = this.state;
                  if (this.state.toView === "overall") {
                    this.premiseGetOverAllExpired().then((result) => {
                      if (
                        result.problem === undefined ||
                        result.problem === null
                      ) {
                        closeModal();
                      } else {
                        this.setState({ isBusy: false });
                      }
                    });
                  }
                  if (this.state.toView === "clusters") {
                    if (clusterId !== null) {
                      this.premiseGetClusterExpired(clusterId).then(
                        (result) => {
                          if (
                            result.problem === undefined ||
                            result.problem === null
                          ) {
                            closeModal();
                          } else {
                            this.setState({ isBusy: false });
                          }
                        }
                      );
                    } else {
                      toastr.confirm(`Please specify a cluster to proceed.`, {
                        disableCancel: true,
                      });
                      this.setState({ isBusy: false });
                    }
                  }
                  if (this.state.toView === "areas") {
                    if (areaId !== null) {
                      this.premiseGetAreaExpired(areaId).then((result) => {
                        if (
                          result.problem === undefined ||
                          result.problem === null
                        ) {
                          closeModal();
                        } else {
                          this.setState({ isBusy: false });
                        }
                      });
                    } else {
                      toastr.confirm(`Please specify area to proceed.`, {
                        disableCancel: true,
                      });
                      this.setState({ isBusy: false });
                    }
                  }
                  if (this.state.toView === "branches") {
                    if (this.state.branches.length > 0) {
                      this.premiseGetBranchExpired(
                        this.state.branches.map((item) => item.value)
                      ).then((result) => {
                        if (
                          result.problem === undefined ||
                          result.problem === null
                        ) {
                          closeModal();
                        } else {
                          this.setState({ isBusy: false });
                        }
                      });
                    } else {
                      toastr.confirm(`Please specify a branch to proceed.`, {
                        disableCancel: true,
                      });
                      this.setState({ isBusy: false });
                    }
                  }
                }}
                className="mt-2 float-right"
              >
                {!this.state.isBusy ? (
                  "View"
                ) : (
                  <Spinner size="sm" animation="border" />
                )}
              </Button>
            </FormGroup>
          </Form.Row>
        </Form>
      </Container>
    );
  }

  getLastMonth = (scopeDate) => {
    var currentMonth = new Date(scopeDate);
    var lastMonth = new Date(moment(scopeDate).subtract(1, "months"));

    lastMonth.setYear(
      currentMonth.getMonth() === 0
        ? currentMonth.getFullYear() - 1
        : currentMonth.getFullYear()
    );
    return new Date(lastMonth);
  };

  getLastYear = (scopeDate) => {
    var currentYear = new Date(scopeDate);
    var lastYear = new Date(scopeDate);
    lastYear.setMonth(currentYear.getMonth());
    lastYear.setYear(currentYear.getFullYear() - 1);
    return new Date(lastYear);
  };

  getAssignedDates = () => {
    var lastMonth = this.getLastMonth(this.state.date);

    let { date } = this.state;
    var current_date = new Date(date);
    if (
      current_date.getMonth() === 0 &&
      current_date.getFullYear() === lastMonth.getFullYear()
    ) {
      lastMonth.setYear(lastMonth.getFullYear() - 1);
    }

    var current = moment(this.state.date).format("YYYY-MM-DD");
    lastMonth = moment(lastMonth).format("YYYY-MM-DD");

    return [
      { covered_date: current },
      // { covered_date: lastYear },
      // { covered_date: lastMonth },
    ];
  };

  getAssignedDailyDates = () => {
    return {
      from: moment(this.state.from).format("YYYY-MM-DD"),
      to: moment(this.state.to).format("YYYY-MM-DD"),
    };
  };

  premiseGetOverAllExpired = () => {
    var dates = this.getAssignedDates();

    var chartTitle = renderChartTitle(
      moduleNames.salesExpired,
      OperationScope.overall,
      moment(dates[0].covered_date).format("MMMM DD YYYY"),
      moment(dates[0].covered_date).format("MMMM DD YYYY")
    );
    this.props.SetChartSalesExpiredTitle(chartTitle);

    return this.props.GetOverallExpired_v4({
      dates: dates,
    });
  };

  premiseGetClusterExpired = (clusterId) => {
    var dates = this.getAssignedDates();
    var chartTitle = renderChartTitle(
      moduleNames.salesExpired,
      OperationScope.specifiedCluster,
      moment(dates[0].covered_date).format("MMMM DD YYYY"),
      moment(dates[0].covered_date).format("MMMM DD YYYY"),
      `${this.state.clusterSelectContext.name} (${this.state.clusterSelectContext.code})`,
      null
    );
    this.props.SetChartSalesExpiredTitle(chartTitle);

    return this.props.GetExpiredByCluster_v4({
      dates: dates,
      clusterId: clusterId,
    });
  };

  premiseGetAreaExpired = (areaId) => {
    var dates = this.getAssignedDates();

    var chartTitle = renderChartTitle(
      moduleNames.salesExpired,
      OperationScope.specifiedArea,
      moment(dates[0].covered_date).format("MMMM DD YYYY"),
      moment(dates[0].covered_date).format("MMMM DD YYYY"),
      null,

      `${this.state.areaSelectContext.areaName} (${this.state.areaSelectContext.areaCode})`
    );
    this.props.SetChartSalesExpiredTitle(chartTitle);

    return this.props.GetExpiredByArea_v4({
      dates: dates,
      areaId: areaId,
    });
  };

  premiseGetBranchExpired = (branch_codes) => {
    var dates = this.getAssignedDates();

    var chartTitle = renderChartTitle(
      moduleNames.salesExpired,
      OperationScope.specifiedBranch,
      moment(dates[0].covered_date).format("MMMM DD YYYY"),
      moment(dates[0].covered_date).format("MMMM DD YYYY"),
      null,
      null,
      `Branch (${branch_codes})`
    );
    this.props.SetChartSalesExpiredTitle(chartTitle);

    return this.props.GetExpiredByBranch_v4({
      dates: dates,
      branch_codes: branch_codes,
    });
  };
}

const mapStateToProps = (state) => {
  return {
    clusters: state.crdm.cluster,
    areas: state.crdm.area,
  };
};

const mapDispatchToProps = {
  GetClusters: GetClusters,
  GetAreas: GetAreas,
  SetChartSalesExpiredTitle: SetChartSalesExpiredTitle,
  GetOverallExpired_v4: GetOverallExpired_v4,
  GetExpiredByArea_v4: GetExpiredByArea_v4,
  GetExpiredByCluster_v4: GetExpiredByCluster_v4,
  GetExpiredByBranch_v4: GetExpiredByBranch_v4,
  GetBranchByCode: GetBranchByCode,
  // GetExpiredByBranch: GetExpiredByBranch,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExpiredViewFilter);
